import { Text, View } from "react-native";

import { formatSetCount } from "@heraion/shared";

import type { SimulationStyles } from "./simulationStyles";

// #355: what the simulator's parts share.

export const formatSets = formatSetCount;

/** Rounds as runs, «W1-W3, W5»: 0-based indexes in, `label` names a round (1-based). */
export const weekRuns = (idx: readonly number[], label: (n: number) => string): string => {
  const runs: string[] = [];
  for (let i = 0; i < idx.length; i += 1) {
    let j = i;
    while (j + 1 < idx.length && idx[j + 1] === idx[j]! + 1) j += 1;
    runs.push(j > i ? `${label(idx[i]! + 1)}-${label(idx[j]! + 1)}` : label(idx[i]! + 1));
    i = j;
  }
  return runs.join(", ");
};

/** A label and its number on one line; the number drops under it when the
 *  two do not fit (font scale, a long word). */
export function Pair({ styles, label, value }: { styles: SimulationStyles; label: string; value: string }) {
  return (
    <View style={styles.pair} accessible accessibilityLabel={`${label}: ${value}`}>
      <Text style={styles.pairLabel}>{label}</Text>
      <Text style={styles.pairValue}>{value}</Text>
    </View>
  );
}
